import { render, staticRenderFns } from "./AccountMessages.vue?vue&type=template&id=6f409bc6&"
import script from "./AccountMessages.vue?vue&type=script&lang=js&"
export * from "./AccountMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports